import React, { useState } from "react";
import "../../scss/Login.css";

const Login = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    // Perform login validation here
    if (email === "demo@mail.com" && password === "password123") {
      setIsLoggedIn(true);
      localStorage.setItem("isLoggedIn", true);
    } else {
      alert("Invalid login credentials");
    }
  };

  if(isLoggedIn){
    window.location.href = "/";
  }

  return (
    <div className="Login-Page">
      <div className="main">
        <div className="left">
            <h1>Classroom Bucket</h1>
            <img src="https://enally.in/cdn/globalImages/cb.png" alt="cb" />
        </div>
        <div className="right">
            <img src="https://ouch-cdn2.icons8.com/LJ9jVY0301Ys8LFtT-M5XRtdcVWFBX3xBpEWyjHD8yQ/rs:fit:512:512/czM6Ly9pY29uczgu/b3VjaC1wcm9kLmFz/c2V0cy9wbmcvOTkv/YTVhNTdmZDEtMzBj/OC00ZjBmLTg2Mjgt/YjFiODhkZDE4YzI3/LnBuZw.png" alt="lock" />
          <h3>Hello Again!</h3>
          <p>Welcome back! We're glad to see you again</p>
          <form onSubmit={handleLogin}>
            <div className="Email">
              <i class="fas fa-at"></i>{" "}
              <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="Password">
              <i class="fas fa-lock-alt"></i>{" "}
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button type="submit">Login</button>
          </form>
          <p>Email: demo@mail.com | Password: password123</p>
        </div>
      </div>
      <div className='footer'>
            <p>&copy; {new Date().getFullYear()} Enally.in All rights reserved. Developed by Prashant Kumar</p>
          </div>
    </div>
  );
};

export default Login;
